import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import meter1 from "../assets/img/meter1.png";
import meter2 from "../assets/img/meter2.png";
import meter3 from "../assets/img/meter3.png";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import colorSharp from "../assets/img/color-sharp.png";
import { useSwiper } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper/modules";
const cardData = [
  {
    img: meter1,
    title: "UI/UX Developement",
  },
  {
    img: meter2,
    title: "Software Development",
  },
  {
    img: meter3,
    title: "Saas Engineer",
  },
  {
    img: meter1,
    title: "Full Stack Development",
  },
];

export const Skills = () => {
  const swiper = useSwiper();

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="services" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx" id="services">
              <h2>My Services</h2>
              <p className="mb-5 font-xs">
                Providing expert web development services, from sleek designs to
                seamless functionality. Let's elevate your online presence.
              </p>
              <Swiper
                modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                spaceBetween={30}
                navigation={true}
                pagination={{
                  clickable: true,
                }}
                className="mySwiper"
                keyboard={true}
                slidesPerView={1}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                  },
                }}
              >
                <>
                  {cardData.map((data) => (
                    <SwiperSlide>
                      {" "}
                      <div class="swiper-slide swiper-slide-card-small">
                        {" "}
                        <div class="small-card">
                          {" "}
                          <div class="small-card-image">
                            <img src={data.img} class="img-fluid" alt="..." />
                          </div>{" "}
                          <h6>{data.title}</h6>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </>{" "}
              </Swiper>

              {/* <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Web Development</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="Image" />
                  <h5>App Development</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="Image" />
                  <h5>Graphics Design</h5>
                </div>
                <div className="item">
                  <img src={meter1} alt="Image" />
                  <h5>Video Editing</h5>
                </div>
              </Carousel> */}
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  );
};
